import { default as CandidateType, CandidateProfileType } from '../../model/hros/recruiting/CandidateType';
import { default as CertificationType } from '../../model/hros/common/profile/CertificationType';
import EffectiveTimePeriodType from '../../model/hros/common/base/EffectiveTimePeriodType';
import { CertificationIsEmpty } from '../../components/profile';
import { ICertificationInstanceForm } from '../../model/forms';
import { DefaultTypeIdentifiersCodeList } from '../../model/hros/common/codelist/DefaultTypeIdentifiersCodeList';

export function ProfileFormCertificationsToHROS(src: Map<number, ICertificationInstanceForm>, dest: CandidateType) : boolean {
  let certifications: CertificationType[] = [];
  if (src.size !== 0) {
    src.forEach((value: ICertificationInstanceForm) => {
      if (CertificationIsEmpty(value)) {
        return;
      }

      let certification: CertificationType = {};
      let certificationModified = false;

      if (value.id !== undefined) {
        certification.id = {
          value: value.id.trim(),
          schemeId: DefaultTypeIdentifiersCodeList.CERTIFICATION_TYPE_IDENTIFIER_SCHEME
        };
        certificationModified = true;
      }

      if (value.name !== undefined) {
        certification.name = value.name.trim();
        certificationModified = true;
      }

      if (value.description !== undefined) {
        certification.descriptions = [ value.description.trim() ];
        certificationModified = true;
      }

      let effectiveTimePeriod: EffectiveTimePeriodType = {};
      let effectiveTimePeriodModified = false;
      if (value.validFrom !== undefined) {
        effectiveTimePeriod.validFrom = value.validFrom.trim();
        effectiveTimePeriodModified = true;
      }
      
      if (value.validTo !== undefined) {
        effectiveTimePeriod.validTo = value.validTo.trim();
        effectiveTimePeriodModified = true;
      }

      if (effectiveTimePeriodModified) {
        certification.effectiveTimePeriod = effectiveTimePeriod;
        certificationModified = true;
      }

      if (certificationModified) {
        certifications.push(certification);
      }
    });
  }
  
  if (certifications.length === 0) {
    return false;
  }

  dest.profiles![0].certifications = certifications;
  return true;
}

export function HROSToProfileFormCertifications(src: CandidateType, dest: Map<number, ICertificationInstanceForm>) {
  if (src?.profiles === undefined || src.profiles.length === 0) {
    return;
  }

  let profile = src.profiles.find((value: CandidateProfileType) => value.profileId?.schemeId === DefaultTypeIdentifiersCodeList.CANDIDATE_PROFILE_TYPE_DEFAULT) || src.profiles[0];
  if (profile.certifications === undefined || profile.certifications.length === 0) {
    return;
  }

  profile.certifications.forEach((value: CertificationType) => {
    let certification: ICertificationInstanceForm = {
      instanceId: dest.size + 1
    };
    let certificationModified = false;

    if (value.id?.value !== undefined) {
      certification.id = value.id.value;
      certificationModified = true;
    }

    if (value.name !== undefined) {
      certification.name = value.name;
      certificationModified = true;
    }

    if (value.descriptions !== undefined && value.descriptions.length > 0) {
      certification.description = value.descriptions[0];
      certificationModified = true;
    }

    if (value.effectiveTimePeriod?.validFrom !== undefined) {
      certification.validFrom = value.effectiveTimePeriod.validFrom;
      certificationModified = true;
    }

    if (value.effectiveTimePeriod?.validTo !== undefined) {
      certification.validTo = value.effectiveTimePeriod.validTo;
      certificationModified = true;
    }

    if (certificationModified) {
      dest.set(certification.instanceId, certification);
    }
  });
}